/* Product card variant selector — pills (radios) + dropdown (select).
   One delegated listener updates each card's price, hidden variant id, and add button. */
(() => {
  'use strict';

  const apply = (card, variant) => {
    if (!variant) return;
    const price = card.querySelector('[data-pc-price]');
    const compare = card.querySelector('[data-pc-compare]');
    const idInput = card.querySelector('[data-pc-id]');
    const addBtn = card.querySelector('[data-pc-add]');

    if (price) price.innerHTML = variant.price;

    if (compare) {
      if (variant.compare) {
        compare.innerHTML = variant.compare;
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    if (idInput) idInput.value = variant.id;

    if (addBtn) {
      // Update only the label span — never addBtn.textContent, which would wipe the
      // spinner, the .sold-out-message hook, and product-form.js's submitButtonText span.
      const label = addBtn.querySelector('[data-pc-label]') || addBtn.querySelector('span');
      const soldOut = addBtn.querySelector('.sold-out-message');
      addBtn.disabled = !variant.available;
      addBtn.removeAttribute('aria-disabled');
      if (label) {
        label.textContent = variant.available ? 'Add to cart' : 'Sold out';
        label.classList.remove('hidden');
      }
      if (soldOut) soldOut.classList.add('hidden');
      // Clear any add-to-cart error left over from a previous (sold-out) selection.
      const err = card.querySelector('.product-form__error-message-wrapper');
      if (err) err.setAttribute('hidden', '');
    }
  };

  const handle = (card, value) => {
    const data = card.querySelector('[data-pc-variants]');
    if (!data) return;
    let variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (_) {
      return;
    }
    apply(
      card,
      variants.find((v) => String(v.id) === String(value))
    );
  };

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.product-card__variant-input');
    if (radio) {
      handle(radio.closest('[data-product-card]'), radio.value);
      return;
    }
    const select = e.target.closest('[data-pc-select]');
    if (select) {
      handle(select.closest('[data-product-card]'), select.value);
    }
  });
})();
